import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { FiArrowLeft } from "react-icons/fi";
// to navigate programmatically

import { Visibility, VisibilityOff } from "@mui/icons-material"; // 👈 Import icons
import IconButton from "@mui/material/IconButton"; // 👈 Import button

const EmployeeLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("employee");
  const [showPassword, setShowPassword] = useState(false); // 👈 State for toggle
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("button clicked");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // important for sending/receiving cookies
          body: JSON.stringify({ email, password, role }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Login successful");
        console.log("Logged in employee:", data.employee);
        localStorage.setItem("token", data.token);
        localStorage.setItem("employeeId", data.employee._id);
        navigate("/employeeDashboard");
        // Save token or user if needed:
        // localStorage.setItem("token", data.token);
        // navigate("/dashboard"); or any page you want to go to
      } else {
        toast.error(data.errors || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <div
        className="back-button"
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#333",
          fontWeight: "bold",
        }}
        onClick={() => navigate("/")}
      >
        <FiArrowLeft size={20} />
        <span>Back</span>
      </div>

      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title"> Login</h2>
          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                className="input-field"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group" style={{ position: "relative" }}>
              <label>Password</label>
              <input
                type={showPassword ? "text" : "password"} // 👈 Toggle type
                className="input-field"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {/* 👁 Toggle Button */}
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                sx={{
                  position: "absolute",
                  right: 10,
                  top: "60%",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
            <div className="mt-4">
              {" "}
              {/* Added margin-top for spacing */}
              <label
                htmlFor="role"
                className="block text-sm font-medium text-gray-700 mb-1.5"
              >
                Select Your Role
              </label>
              <div className="relative rounded-md shadow-sm">
                {" "}
                {/* Wrapper for better styling */}
                <select
                  id="role"
                  name="role"
                  className="block w-full pl-4 pr-12 py-2.5 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 rounded-lg transition-all duration-200"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="employee">Employee</option>
                  <option value="other">Other Role</option>
                </select>
              </div>
            </div>
            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default EmployeeLogin;
